import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { chapters } from '../../data/bookData';
import { FiChevronDown } from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';

const ChapterItem = ({ chapter, index }) => {
  const [open, setOpen] = useState(false);

  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ delay: index * 0.05 }}
      className="bg-brand-dark border border-white/5 rounded-2xl overflow-hidden hover:border-brand-accent/20 transition-colors"
    >
      <button
        onClick={() => setOpen(!open)}
        className="w-full flex items-center gap-5 p-6 text-left"
      >
        <div className="flex-shrink-0 w-12 h-12 rounded-full bg-brand-accent/10 border border-brand-accent/30 flex items-center justify-center">
          <span className="text-brand-accent font-display font-bold">{chapter.num}</span>
        </div>
        <div className="flex-1 min-w-0">
          <div className="flex flex-wrap gap-3 mb-1">
            <span className="text-xs text-brand-accent font-medium">{chapter.era}</span>
            <span className="text-xs text-gray-600">·</span>
            <span className="text-xs text-gray-500">{chapter.world}</span>
          </div>
          <h3 className="text-white font-display font-bold text-lg">{chapter.title}</h3>
        </div>
        <SafeIcon
          icon={FiChevronDown}
          className={`text-gray-500 text-xl flex-shrink-0 transition-transform duration-300 ${open ? 'rotate-180' : ''}`}
        />
      </button>
      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: 'auto', opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.3 }}
            className="overflow-hidden"
          >
            <div className="px-6 pb-6 pt-0 border-t border-white/5">
              <p className="text-gray-400 leading-relaxed pt-4">{chapter.desc}</p>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </motion.div>
  );
};

const ChaptersGrid = () => (
  <section className="py-16 bg-brand-surface border-t border-white/5">
    <div className="max-w-3xl mx-auto px-6 lg:px-8">
      <div className="space-y-4">
        {chapters.map((chapter, i) => (
          <ChapterItem key={chapter.num} chapter={chapter} index={i} />
        ))}
      </div>
    </div>
  </section>
);

export default ChaptersGrid;